module.exports = __webpack_public_path__ + "static/media/DiSC_Profile.2b71ccf2.png";